/* 评论相关API */
import { Get, Post } from "@common";
import Qs from "qs";
export default {
  /*查询权限*/
  queryPower() {
    return Get(CONFIG.BASE_URL + "/spc/discuss/getGlobalDiscussRule.do");
  },
  // 查询用户信息
  queryUser() {
    return Get(CONFIG.BASE_URL + "/checkToken.do");
  },
  // 上传图片
  uploadImage(params) {
    return Post(CONFIG.BASE_URL + "/spc/subject/uploadImage.do", params);
  },
  // 提交评论
  saveDiscuss(params) {
    return Post(CONFIG.BASE_URL + "/spc/discuss/saveDiscuss.do", params);
  },
  // 获取评论列表
  queryList(params) {
    return Post(
      CONFIG.BASE_URL + "/spc/discuss/findDiscussByArticle.do",
      Qs.stringify(params),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  },
  // 获取用户用评论看法
  queryState(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/getDiscussStates.do", {
      params: params
    });
  },
  // 获取二级评论
  queryListById(params) {
    return Post(
      CONFIG.BASE_URL + "/spc/discuss/getListByParentDiscussId.do",
      Qs.stringify(params),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  },
  // 点赞评论
  setLikeAdd(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/like/add.do", {
      params: params
    });
  },
  // 取消点赞评论
  setLikeDel(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/like/del.do", {
      params: params
    });
  },
  // 点踩评论
  setUnlikeAdd(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/unlike/add.do", {
      params: params
    });
  },
  // 取消点赞评论
  setUnlikeDel(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/unlike/del.do", {
      params: params
    });
  },
  // 收藏评论
  setCollectAdd(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/collect/add.do", {
      params: params
    });
  },
  // 取消收藏评论
  setCollectDel(params) {
    return Get(CONFIG.BASE_URL + "/spc/discuss/state/collect/del.do", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/work/bookReview/common/api/bookReviewApi.js